var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 64,
    viewBox: "0 0 79 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 62.0004L22.2987 52.9517M22.2987 52.9517C23.8463 54.4992 25.6835 55.7268 27.7055 56.5644C29.7274 57.4019 31.8946 57.8329 34.0831 57.8329C36.2717 57.8329 38.4388 57.4019 40.4608 56.5644C42.4827 55.7268 44.3199 54.4992 45.8675 52.9517C47.415 51.4042 48.6426 49.5669 49.4801 47.545C50.3177 45.523 50.7487 43.3559 50.7487 41.1673C50.7487 38.9788 50.3177 36.8116 49.4801 34.7897C48.6426 32.7677 47.415 30.9305 45.8675 29.383C42.7421 26.2575 38.5031 24.5017 34.0831 24.5017C29.6631 24.5017 25.4242 26.2575 22.2987 29.383C19.1733 32.5084 17.4175 36.7473 17.4175 41.1673C17.4175 45.5873 19.1733 49.8263 22.2987 52.9517Z",
    stroke: "#363636",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75003 43.955C3.28661 39.711 1.99264 34.8896 2.00003 29.9825C2.00003 14.5287 14.5925 2 30.125 2H48.875C64.4075 2 77 14.5287 77 29.9825C77 42.17 69.1738 52.535 58.25 56.375",
    stroke: "#363636",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmo);
export default __webpack_public_path__ + "static/media/SMO.344acc95ea77db09bf8ef21d66c07419.svg";
export { ForwardRef as ReactComponent };